<template>
  <v-container class="px-0">
    <v-row no-gutters v-for="(item, index) in diagnoses" :key="index">
      <v-col>
        <v-row no-gutters>
          <v-col >
            <span class="text-overline-head grey--text text--darken-1 pr-2">({{ item.code || '' }})</span>
            <span class="text-caption">{{ item.name }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Diagnosis',
  props: {
    diagnoses: {
      type: Array,
      default: () => []
    }
  }
}
</script>